export default __webpack_public_path__ + "static/media/twitter.aba26974.jpeg";